//This is useful when the endpoints are changed to actual API. Mainly required to support mock testing.
const HeartbeatEndpoints = {
  Heartbeat: '/api/Health/heartbeat',
}

const BookmarksEndpoints = {
  GetBookmarks: '/api/user/GetBookmarks',
  CreateBookmark: '/api/user/AddBookmark',
  RemoveBookmark: '/api/user/RemoveBookmark',
}
const ProfilesEndpoints = {
  CurrentUser: '/api/user',
  GetUpdateUserViewModel: '/api/user/GetUpdateUserViewModel',
  GetRegisterUserViewModel: '/api/user/GetRegisterUserViewModel',
  RegisterUser: '/api/user/RegisterUser',
  Patch: '/api/user/UpdateUser',
  ResetPin: '/api/user/UpdatePIN',
  ResetPassword: '/api/user/resetPassword',
  PasswordUpdated: '/api/user/passwordUpdated',
  ChangePhoneNumber: '/api/user/deletePhoneNumber',
  ChangeEmailAddress: '/api/user/deleteEmailAddress',
  Logon: '/api/user/logon',
  DisableUser: '/api/user/DisableUser',
  ChangeUserEmailAddress: '/api/user/ChangeUserEmail',
  ChangeABN: '/api/user/UpdateABN',
  InitiateMFAPhoneChange: '/api/user/InitiateChangeMFAPhone',
  ChangeMFAPhone: '/api/user/ChangeMFAPhone',
}

const EnquiriesEndpoints = {
  All: '/api/enquiry',
  Create: '/api/enquiry/CreateEnquiry',
  GetEnquiryDetails: '/api/enquiry',
  GetUpdateEnquiryStep1ViewModel: '/api/enquiry/GetUpdateEnquiryStep1ViewModel',
  GetUpdateEnquiryStep2ViewModel: '/api/enquiry/GetUpdateEnquiryStep2ViewModel',
  SaveStepOne: '/api/enquiry/UpdateEnquiryStep1',
  SaveStepTwo: '/api/enquiry/UpdateEnquiryStep2',
  Submit: '/api/enquiry/SubmitEnquiry',
  UpdateRequestInformation: '/api/enquiry/AddResponseToRequestForInformation',
  Cancel: '/api/enquiry/Cancel',
  Close: '/api/enquiry/Close',
  ChangeABN: '/api/enquiry/UpdateABN',
  RootEnquiry: '/api/Enquiry',
}

const AbrEndpoints = {
  GetAbnDetails: '/api/abnsearch/GetABNDetails',
  GetAbnMatchingNames: '/api/abnsearch/GetAbnMatchingNames',
}

const RefDataEndpoints = {
  Titles: '/api/ReferenceData/Title',
  CustomerTypes: '/api/ReferenceData/CustomerTypes',
  Awards: '/api/ReferenceData/ModernAwards',
  Genders: '/api/ReferenceData/Gender',
  Industries: '/api/ReferenceData/AwardIndustry',
  SubIndustries: '/api/ReferenceData/AwardSubIndustry',
  SubIndustry: '/api/ReferenceData/AwardSubIndustry/{id}',
  Regions: '/api/ReferenceData/Region',
  BusinessDescriptions: '/api/ReferenceData/BusinessDescriptions',
  YesNoUnsure: '/api/ReferenceData/YesNoUnsure',
  RequestForAssistanceInfoCategories:
    '/api/ReferenceData/RequestForAssistanceInfoCategories',
  RequestForAssistanceInfoSubCategories:
    '/api/ReferenceData/RequestForAssistanceInfoSubCategories',
  Issues: '/api/ReportReferenceData/Issue/',
  SubIssues: '/api/ReportReferenceData/SubIssue/',
  EmploymentTypes: '/api/ReferenceData/EmploymentTypes',
  ApprenticeTrainee: '/api/ReferenceData/ApprenticeTrainee',
  EmployeeDescriptions: '/api/ReferenceData/EmployeeDescriptions',
  HowDidYouFind: '/api/ReferenceData/HowDidYouFind',
  VisaTypes: '/api/ReferenceData/VisaTypes',
  OfficeLocations: '/api/ReferenceData/OfficeLocations',
  Languages: 'api/ReferenceData/Language',
  EmploymentAttributes: '/api/ReportReferenceData/EmploymentAttribute/',
  ReportIndustries: '/api/ReportReferenceData/Industry/',
  ReportSubIndustries: '/api/ReportReferenceData/SubIndustry/',
  GenuineContractEmployees: '/api/ReferenceData/GenuineContractEmployee/',
  Countries: '/api/ReferenceData/country/',
  Occupations: '/api/ReferenceData/Occupation/',
  ReasonNotSpokenToEmployers: '/api/ReferenceData/ReasonNotSpokenToEmployers',
  Evidences: '/api/ReferenceData/Evidence',
  CountryCodes: '/api/ReferenceData/CountryCodes',
}

const AddressEndpoints = {
  GetLocations: '/api/address',
}

const TranscriptEndpoints = {
  GetTranscript: '/api/transcript',
}

const GovCMSEndpoints = {
  GetRecomendedCMSPages: '/api/fairwork/cmspages/search',
  GetNewsAlertsCMSPages: '/api/fairwork/GetNewsAlerts',
}

const CalloutEndpoints = {
  GetCalloutByPage: '/api/Callout/GetCalloutsByPage/{page}',
}
const Resources = {
  HeartbeatEndpoints,
  ProfilesEndpoints,
  EnquiriesEndpoints,
  AbrEndpoints,
  RefDataEndpoints,
  AddressEndpoints,
  TranscriptEndpoints,
  GovCMSEndpoints,
  BookmarksEndpoints,
  CalloutEndpoints,
}

export default Resources
